import { useCallback, useMemo, useState } from 'react';
import {
  buildSearchParams,
  getPageSearchTypes,
} from '../../config/searchConfig';

// Stanje jedinstvene pretrage za jednu stranicu (vidi src/config/searchConfig.js).
// `params` je objekat query parametara za API ({ userSearch, lboSearch, ... }).
// Pretraga se primenjuje tek izborom opcije, pa nema potrebe za debounce-om.
export default function useTableSearch(pageKey) {
  const [entries, setEntries] = useState([]);

  const types = useMemo(() => getPageSearchTypes(pageKey), [pageKey]);
  const params = useMemo(
    () => buildSearchParams(pageKey, entries),
    [pageKey, entries]
  );
  const reset = useCallback(() => setEntries([]), []);

  return {
    types,
    entries,
    onChange: setEntries,
    params,
    isActive: entries.length > 0,
    reset,
  };
}
